import type { YachtPlayerScoreSheet, YachtRanking } from "../types";

export function buildRankings(
  seatingOrder: readonly string[],
  scoreSheetsByPlayerId: Readonly<Record<string, YachtPlayerScoreSheet>>,
): readonly YachtRanking[] {
  const sorted = seatingOrder
    .map((playerId) => ({
      playerId,
      total: scoreSheetsByPlayerId[playerId]?.total ?? 0,
    }))
    .sort((a, b) => b.total - a.total);

  let lastTotal: number | null = null;
  let lastRank = 0;

  return sorted.map((entry, index) => {
    const rank = lastTotal === entry.total ? lastRank : index + 1;
    lastTotal = entry.total;
    lastRank = rank;
    return {
      rank,
      playerId: entry.playerId,
      total: entry.total,
    };
  });
}
